import { useContext } from 'react'
import { FlashcardsStateContext } from './flashcards-state'

export function useFlashcardsState() {
  const value = useContext(FlashcardsStateContext)

  if (!value) {
    throw new Error('useFlashcardsState must be used inside FlashcardsStateProvider.')
  }

  return value
}
